import classnames from 'classnames';
import { Button } from 'palette/Button';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ONE_LABEL } from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';

export default function ActiveFilterButton({
    className,
    activeFilter,
    theme,
    filterClick
}) {
    const translate = useTranslation();

    const handleClick = () => {
        pushGAEventToDataLayer(GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ONE_LABEL);
        filterClick(activeFilter);
    };

    return (
        <Button
            className={classnames(className, {
                'active-filter-button-v2': theme === 'mod1'
            })}
            iconName="palette_close"
            label={translate(activeFilter.name)}
            size="small"
            theme="secondary"
            onClick={handleClick}
        />
    );
}
